/**
 * Section B2 Service
 * B.2.適用性 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/section-b2';

// ========== Types ==========

export interface SectionB2Detail {
  id: number;
  organization_id: number;
  project_id: number;
  mothed_references: number;
  applicability_codition: string | null;
  project_compliance: string | null;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface SectionB2Create {
  project_id: number;
  mothed_references: number;
  applicability_codition?: string;
  project_compliance?: string;
}

export interface SectionB2Update {
  mothed_references?: number;
  applicability_codition?: string;
  project_compliance?: string;
}

// ========== API ==========

export const getListByProject = async (projectId: number): Promise<SectionB2Detail[]> => {
  const response = await axios.get<SectionB2Detail[]>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

export const create = async (data: SectionB2Create): Promise<SectionB2Detail> => {
  const response = await axios.post<SectionB2Detail>(BASE_URL + '/', data);
  return response.data;
};

export const update = async (id: number, data: SectionB2Update): Promise<SectionB2Detail> => {
  const response = await axios.put<SectionB2Detail>(`${BASE_URL}/${id}`, data);
  return response.data;
};

export const deleteItem = async (id: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${id}`);
};

const sectionB2Service = {
  getListByProject,
  create,
  update,
  delete: deleteItem
};

export default sectionB2Service;
